'use client';

import React from 'react';
import { EVENTS } from '@/constants/tracking';
import { TolstoyService } from '@/features/integrations';
import { TolstoyIntegration } from './TolstoyIntegration';

const INTEGRATION_STEPS = [
  'Add Tolstoy to your Shopify store.',
  'Once in Tolstoy, your videos will all automatically be available in the Library tab.',
  <span key="shop-step-3">
    Go to the <strong>Shop tab</strong> where you can enable videos on the Shop home feed and on your storefront&apos;s
    home page and product pages
  </span>,
];

const SHOP_SUMMARY = `Showcase your Bunu videos to millions of potential customers on the Shop app’s home feed to enhance your brand visibility, highlight top products and boost their engagement.`;

const EXAMPLES = [
  {
    src: '/assets/shop-videos.jpg',
    alt: 'Get seen by 100M shoppers',
  },
  {
    src: '/assets/shop-videos-example-1.jpg',
    alt: 'Product showcase in Shop app',
  },
  {
    src: '/assets/shop-videos-example-2.jpg',
    alt: 'Interactive shopping experience',
  },
];

const PublishShop: React.FC = () => {
  return (
    <TolstoyIntegration
      title="Feature your videos to millions of Shop app users, for free."
      summary={SHOP_SUMMARY}
      integrationSteps={INTEGRATION_STEPS}
      examples={EXAMPLES}
      publishEvent={EVENTS.PUBLISH_ON_SHOP_WITH_TOLSTOY}
      getTolstoyEvent={EVENTS.GET_TOLSTOY_TO_PUBLISH_ON_SHOP}
      redirectRoute={TolstoyService.Routes.ShopApp}
    />
  );
};

export default PublishShop;
